import { is } from 'stdlib/is'

import styles from './Img.css'

interface IProps {
  readonly src: string | string[]
  readonly alt?: string
  readonly isResponsive?: boolean
  readonly isLazy?: boolean
  readonly height?: number | string
  readonly width?: number | string
  readonly placeholder?: string
  readonly className?: string
}

/**
 * Dinamikusan betöltölthető, reszponzív kép factory-ja.
 * @param props - JSX props {@link IProps}.
 */
export default function Img (props: IProps): HTMLImageElement {
  const img: HTMLImageElement = (
    <img className={ [ styles.img, props.className ?? '' ] } draggable={ false } />
  )

  if (props.alt) {
    img.alt = props.alt
  }

  if (props.height) {
    img.setAttribute('height', `${ props.height }`)
    img.style.height = is.string(props.height) ? props.height : `${ props.height }px`
  }

  if (props.width) {
    img.setAttribute('width', `${ props.width }`)
    img.style.width = is.string(props.width) ? props.width : `${ props.width }`
  }

  if (props.isResponsive) {
    img.classList.add(styles.responsive)
  }

  if (props.placeholder) {
    img.src = props.placeholder
  }

  /* eslint-disable custom/no-nested-ternary -- Legacy. */
  const src = is.undefined(props.src)
    ? null
    : is.array(props.src)
      ? props.src.join(',')
      : props.src
  /* eslint-enable custom/no-nested-ternary -- Legacy. */

  if (!is.null(src)) {
    if (props.isLazy) {
      img.setAttribute('data-src', src) // TODO: lazy
    }
    else {
      img.src = src
    }
  }

  return img
}
